import React from "react";
import './common.css';

export default function SaralContact() {
  return (
    <div className="container">
      <header className="header">
        <h1 className="logo">Saral Platform</h1>
        <nav className="nav">
          <a href="/">Home</a>
          <a href="/SaralModeration">Moderation</a>
          <a href="/SaralTranslate">Translation</a>
        </nav>
      </header>

      <section className="intro" style={{
        backgroundImage: 'linear-gradient(rgba(102, 126, 234, 0.85), rgba(118, 75, 162, 0.85)), url(https://images.unsplash.com/photo-1556761175-4b46a572b786?w=1200&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <h2 className="intro-tagline">Managed CCaaS</h2>
        <p className="intro-subtitle">Transforming from cost centers → experience centers, powered by AI</p>
      </section>

      <section style={{padding: '3rem 2rem', background: '#f9f9f9'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden'}}>
            <iframe
              style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%'}}
              src="https://www.youtube.com/embed/coL6PiP6Ams"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </section>

      <section className="features">
        <h3>What is CCaaS?</h3>
        <div style={{maxWidth: '900px', margin: '0 auto', textAlign: 'left', padding: '0 2rem'}}>
          <p style={{fontSize: '1.3rem', marginBottom: '2rem', fontWeight: '500'}}>
            Contact Center as a Service (CCaaS) is a cloud-based contact centre platform that offers customer-facing communication (voice, chat, email, SMS, social) as a service, rather than requiring on-premises hardware.
          </p>
        </div>
      </section>

      <section className="features">
        <h3>What is Managed CCaaS?</h3>
        <div style={{maxWidth: '900px', margin: '0 auto', textAlign: 'left', padding: '0 2rem'}}>
          <p style={{fontSize: '1.3rem', marginBottom: '1.5rem', fontWeight: '500'}}>
            Saral Platform offers following operational management services in addition to delivering the CCaaS platform:
          </p>
          <ul style={{fontSize: '1.1rem', lineHeight: '2', listStyle: 'disc', paddingLeft: '2rem'}}>
            <li><strong>Platform Provisioning & Configuration:</strong> Set up the CCaaS environment, create queues, IVR flows, routing rules, and channel integrations (SMS, chat, voice).</li>
            <li><strong>Service-Level Management:</strong> Ensuring uptime, performance, scalability, and meeting KPIs for contact-centre operations (e.g., average hold time, first call resolution).</li>
            <li><strong>Ongoing Operations:</strong> Monitoring, updates, patching, managing users/agents, and license management.</li>
            <li><strong>Channel Expansion:</strong> Added services like SMS, chatbots, and social media messaging managed for you rather than building them yourself.</li>
            <li><strong>Analytics & Optimization:</strong> Running reports, making recommendations on call volume surges, agent productivity, and channel mix.</li>
            <li><strong>Compliance & Security:</strong> Ensuring the solution meets regulatory standards (HIPAA, PCI, GDPR), data-residency, audits, etc.</li>
            <li><strong>Support & Incident Management:</strong> We handle incidents, support for agents, and escalations.</li>
            <li><strong>Workforce Management:</strong> Scheduling agents, forecasting volume, shift planning, and quality monitoring.</li>
          </ul>
        </div>
      </section>

      <section className="features">
        <h3>Why Businesses Choose Managed CCaaS</h3>
        <div style={{maxWidth: '900px', margin: '0 auto', textAlign: 'left', padding: '0 2rem'}}>
          <ul style={{fontSize: '1.1rem', lineHeight: '2', listStyle: 'disc', paddingLeft: '2rem'}}>
            <li><strong>Less Internal Burden:</strong> No need to hire or maintain specialist telephony/contact center systems teams.</li>
            <li><strong>Faster Time to Value:</strong> We handle setup and operations, so you can focus on your business.</li>
            <li><strong>Scalability & Flexibility:</strong> Cloud + managed ops means easier to scale up/down with business needs.</li>
            <li><strong>Focus on Business Outcomes:</strong> Concentrate on business outcomes vs infrastructure management.</li>
            <li><strong>Multi-Channel & Global Support:</strong> Better support for multi-channel, global, and remote-agent scenarios.</li>
          </ul>
        </div>
      </section>

      <section className="features">
        <h3>The Future: AI-First Contact Centers</h3>
        <div className="feature-list">
          <div className="feature">
            <div className="feature-icon">🤖</div>
            <h4>70-90% AI-Resolved</h4>
            <p>AI handles Tier-1 & Tier-2 interactions: routine inquiries, password resets, order tracking, FAQs, basic troubleshooting.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🤝</div>
            <h4>10-30% Human-Led</h4>
            <p>Humans handle high-judgment scenarios: angry customers, legal/compliance issues, enterprise sales, executive escalations.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">🧩</div>
            <h4>Experience Orchestration</h4>
            <p>Agents don't just "answer calls" - they manage AI, resolve escalations, and build customer relationships.</p>
          </div>
        </div>
      </section>

      <section id="contact" className="contact">
        <h3>Ready to Transform Your Contact Center?</h3>
        <p style={{fontSize: '1.2rem', marginBottom: '1.5rem'}}>
          "Every customer interaction starts with AI, most end with AI, and the ones that don't are handled by the best humans — fully informed and empowered."
        </p>
        <p>Let's build your AI-first resolution platform together.</p>
        <p>Email us at <a href="mailto:mandar@saralplatform.com">mandar@saralplatform.com</a></p>
        <p>Call us at <a href="tel:770-378-8627">770-378-8627</a></p>
      </section>

      <footer className="footer">
        &copy; 2025 Saral Platform. All rights reserved.
      </footer>
    </div>
  );
}
